import { Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Panel from './Panel';

const ReferralPanel = ({ rewardText, code, onCopy, onNavigate }) => (
  <Panel title="Refer and earn" actionLabel="Details" onViewAll={() => onNavigate('/referrals')} testId="referral-banner">
    <p className="text-sm text-muted-foreground mb-3">Earn {rewardText} for each successful referral.</p>
    <div className="flex items-center justify-between gap-3 border border-border rounded-md px-3 py-2">
      <span className="font-mono text-sm">{code}</span>
      <Button variant="outline" size="sm" onClick={onCopy}>
        <Copy className="w-3.5 h-3.5 mr-1.5" />
        Copy
      </Button>
    </div>
  </Panel>
);

export default ReferralPanel;
